module.exports = __webpack_public_path__ + "static/img/media_8.d38fb03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/media_8.png
// module id = aUav
// module chunks = 1